// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import detectEthereumProvider from '@metamask/detect-provider';
import { useLocation } from 'react-router-dom';
import '../style/Navbar.css';
import Web3 from 'web3';
import { ToastContainer, toast } from 'react-toastify';

const Navbar = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [account, setAccount] = useState('');
  const location = useLocation();
  const { walletAddress } = location.state || {};

  useEffect(() => {
    const checkConnection = async () => {
      const provider = await detectEthereumProvider();
         // Check network ID
         const web3 = new Web3(provider);
         const networkId = await web3.eth.net.getId();
         if (Number(networkId) !== 80002) { // 80002 is the network ID for Polygon Mumbai testnet
             toast.error('You are not connected to the correct network. Please switch to the Polygon Amoy testnet.');
             return; // Stop execution if network is incorrect
         }
      if (provider) {
        const accounts = await provider.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
          setAccount(accounts[0]);
          setIsConnected(true);
        } else {
          setIsConnected(false);
        }

        // Set up event listeners
        provider.on('accountsChanged', (accounts) => {
          if (accounts.length > 0) {
            setAccount(accounts[0]);
            setIsConnected(true);
            window.location.reload(); // Refresh the page on account change
          } else {
            setAccount('');
            setIsConnected(false);
            window.location.reload(); // Refresh the page if no accounts are available
          }
        });

        provider.on('chainChanged', (chainId) => {
          // Handle chain change if necessary
          console.log('Chain changed to', chainId);
          window.location.reload(); // Refresh the page on network change
        });

      } else {
        console.error('MetaMask is not installed.');
      }
    };

    checkConnection();

    // Cleanup function to remove listeners
    return () => {
      const provider = window.ethereum;
      if (provider) {
        provider.removeAllListeners('accountsChanged');
        provider.removeAllListeners('chainChanged');
      }
    };
  }, []);

  const connectMetaMask = async () => {
    const provider = await detectEthereumProvider();
    if (provider) {
      try {
        const accounts = await provider.request({ method: 'eth_requestAccounts' });
        if (accounts.length > 0) {
          setAccount(accounts[0]);
          setIsConnected(true);
        }
      } catch (error) {
        console.error('User rejected the request:', error);
      }
    } else {
      console.error('MetaMask is not installed.');
    }
  };

  // Get the first 10 characters of the account address
  const shortenedAccount = account.slice(0, 10);

  return (
    <nav className="navbar">
      <div className="navbar-links">
        <Link to="/" className="home-link">Home</Link>
        <Link to="/employee">Employee</Link>
        <Link to="/admin">Admin</Link>
        <Link to="/verifier">Verifier</Link>
      </div>
      <div className="navbar-connect">
        <span
          className={`status-dot ${isConnected ? 'connected' : 'disconnected'}`}
        ></span>
        {isConnected ? (
          <span className="account-info">{shortenedAccount}</span>
        ) : (
          <button onClick={connectMetaMask}>Connect MetaMask</button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
